import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export const PageShell = ({ title, intro, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-cream min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24 px-6 sm:px-8 lg:px-12">
        <div className="mx-auto max-w-3xl">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-sage-deep hover:text-sage transition-colors" data-testid="back-home">
            <ArrowLeft size={16} /> Back to home
          </Link>
          <h1 className="mt-6 font-serif text-4xl sm:text-5xl tracking-tight text-heading">{title}</h1>
          {intro && <p className="mt-4 text-ink/70 leading-relaxed">{intro}</p>}
          <div className="mt-10 space-y-8 text-ink/80 leading-relaxed">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const Block = ({ heading, children }) => (
  <section>
    <h2 className="font-serif text-2xl font-semibold text-heading mb-2">{heading}</h2>
    <div className="space-y-3 text-base leading-relaxed">{children}</div>
  </section>
);
